import { useNavigate } from "react-router-dom";

export default function RewardsGuest() {
  const navigate = useNavigate();

  const tiers = [
    { icon: "ri-medal-line",       color: "text-amber-700",  bg: "bg-amber-700/10",  label: "برونزي",  range: "0–99" },
    { icon: "ri-medal-2-line",     color: "text-gray-300",   bg: "bg-gray-300/10",   label: "فضي",     range: "100–299" },
    { icon: "ri-vip-crown-line",   color: "text-amber-400",  bg: "bg-amber-400/10",  label: "ذهبي",    range: "300–599" },
    { icon: "ri-vip-diamond-line", color: "text-cyan-300",   bg: "bg-cyan-300/10",   label: "بلاتيني", range: "600+" },
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] px-4 py-16" dir="rtl">
      {/* Background glow */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 right-1/4 w-[500px] h-[500px] bg-amber-400/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/3 left-1/4 w-[300px] h-[300px] bg-amber-400/3 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-2xl mx-auto">
        {/* Back */}
        <a
          href="/"
          className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-300 text-sm transition-colors cursor-pointer mb-10"
          style={{ fontFamily: "'Cairo', sans-serif" }}
        >
          <i className="ri-arrow-right-line"></i>
          العودة للمتجر
        </a>

        {/* Hero */}
        <div className="relative bg-gradient-to-br from-amber-400/20 via-amber-400/5 to-transparent border border-amber-400/30 rounded-3xl p-8 mb-6 overflow-hidden text-center">
          <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-amber-400/0 via-amber-400/80 to-amber-400/0"></div>
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-48 h-48 bg-amber-400/10 rounded-full blur-3xl pointer-events-none"></div>

          <div className="w-20 h-20 flex items-center justify-center bg-amber-400/15 border border-amber-400/30 rounded-3xl mx-auto mb-5">
            <i className="ri-vip-crown-2-line text-amber-400 text-4xl"></i>
          </div>

          <h1 className="text-white text-3xl font-black mb-3" style={{ fontFamily: "'Cairo', sans-serif" }}>
            برنامج المكافآت
          </h1>
          <p className="text-gray-400 text-sm leading-relaxed max-w-md mx-auto mb-6" style={{ fontFamily: "'Cairo', sans-serif" }}>
            اكسب نقاطاً على كل طلب تستلمه، وارقَ في المستويات للحصول على خصومات وهدايا حصرية
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate("/auth")}
              className="flex items-center justify-center gap-2 bg-amber-400 hover:bg-amber-300 text-black font-black px-6 py-3 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Cairo', sans-serif" }}
            >
              <i className="ri-user-add-line"></i>
              سجّل الآن وابدأ
            </button>
            <button
              onClick={() => navigate("/")}
              className="flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-gray-300 font-bold px-6 py-3 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Cairo', sans-serif" }}
            >
              <i className="ri-store-2-line"></i>
              تسوق أولاً
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-3 mb-6">
          {[
            { icon: "ri-coins-line",       color: "text-amber-400", value: "1 نقطة",   label: "لكل 10 ر.س" },
            { icon: "ri-vip-diamond-line", color: "text-cyan-300",  value: "4",         label: "مستويات عضوية" },
            { icon: "ri-gift-2-line",      color: "text-rose-400",  value: "مزايا",     label: "حصرية لكل مستوى" },
          ].map((s, i) => (
            <div key={i} className="bg-[#111] border border-white/8 rounded-2xl p-4 text-center">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                <i className={`${s.icon} ${s.color} text-2xl`}></i>
              </div>
              <p className={`text-base font-black ${s.color}`} style={{ fontFamily: "'Cairo', sans-serif" }}>{s.value}</p>
              <p className="text-gray-600 text-[11px] mt-0.5" style={{ fontFamily: "'Cairo', sans-serif" }}>{s.label}</p>
            </div>
          ))}
        </div>

        {/* Tiers preview */}
        <div className="bg-[#111] border border-white/8 rounded-3xl p-6 mb-6">
          <h2 className="text-white text-sm font-black mb-4 flex items-center gap-2" style={{ fontFamily: "'Cairo', sans-serif" }}>
            <i className="ri-bar-chart-grouped-line text-amber-400"></i>
            مستويات العضوية
          </h2>
          <div className="grid grid-cols-2 gap-3">
            {tiers.map((t) => (
              <div key={t.label} className={`${t.bg} border border-white/5 rounded-2xl p-4 flex items-center gap-3`}>
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className={`${t.icon} ${t.color} text-2xl`}></i>
                </div>
                <div>
                  <p className={`font-black text-sm ${t.color}`} style={{ fontFamily: "'Cairo', sans-serif" }}>{t.label}</p>
                  <p className="text-gray-600 text-[11px]" style={{ fontFamily: "'Cairo', sans-serif" }}>{t.range} نقطة</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA bottom */}
        <div className="bg-[#111] border border-white/8 rounded-3xl p-6 text-center">
          <p className="text-gray-400 text-sm mb-4" style={{ fontFamily: "'Cairo', sans-serif" }}>
            لديك حساب بالفعل؟ سجّل دخولك لعرض نقاطك
          </p>
          <button
            onClick={() => navigate("/auth")}
            className="flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-gray-300 font-bold px-6 py-3 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap mx-auto"
            style={{ fontFamily: "'Cairo', sans-serif" }}
          >
            <i className="ri-login-box-line"></i>
            تسجيل الدخول
          </button>
        </div>
      </div>
    </div>
  );
}
